// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-button-doc-mdx": () => import("./../../../src/pages/button-doc.mdx" /* webpackChunkName: "component---src-pages-button-doc-mdx" */),
  "component---src-pages-contribution-mdx": () => import("./../../../src/pages/contribution.mdx" /* webpackChunkName: "component---src-pages-contribution-mdx" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-philosophy-mdx": () => import("./../../../src/pages/philosophy.mdx" /* webpackChunkName: "component---src-pages-philosophy-mdx" */),
  "component---src-pages-team-mdx": () => import("./../../../src/pages/team.mdx" /* webpackChunkName: "component---src-pages-team-mdx" */),
  "component---src-pages-text-input-doc-mdx": () => import("./../../../src/pages/text-input-doc.mdx" /* webpackChunkName: "component---src-pages-text-input-doc-mdx" */)
}

